module.exports = __webpack_public_path__ + "static/media/hangman04.d5c2f7ed.svg";